// extracted by mini-css-extract-plugin
module.exports = {"time":"Period_time__261L6","hyphen":"Period_hyphen__2jJGx"};